import React from 'react';
import { FieldRow, Field } from './EditShared';
import styles from './EditContactSection.module.css';

function InstagramInput({ value, onChange }) {
  const handleChange = (e) => {
    let v = e.target.value;
    // @ 제거 후 상태 저장 (표시는 prefix로)
    if (v.startsWith('@')) v = v.slice(1);
    onChange(v);
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <span style={{
        position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)',
        fontSize: '15px', fontWeight: 500, color: '#090909', pointerEvents: 'none', userSelect: 'none', lineHeight: 1,
      }}>@</span>
      <input
        value={value || ''}
        onChange={handleChange}
        placeholder="아이디 입력"
        style={{
          width: '100%', boxSizing: 'border-box',
          paddingLeft: '28px', paddingRight: '14px', paddingTop: '12px', paddingBottom: '12px',
          border: '1px solid #E9E9EC', borderRadius: '10px',
          fontSize: '15px', fontFamily: 'Pretendard, sans-serif', color: '#090909',
          outline: 'none', background: '#fff',
        }}
      />
    </div>
  );
}

function formatPhone(value) {
  if (!value) return '';
  const digits = String(value).replace(/\D/g, '');
  if (digits.length === 11) return `${digits.slice(0,3)}-${digits.slice(3,7)}-${digits.slice(7)}`;
  if (digits.length === 10) return `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`;
  return value;
}

export default function EditContactSection({
  email,
  setEmail,
  phone,
  setPhone,
  instagram,
  setInstagram,
  youtube,
  setYoutube,
  hideHeader = false,
}) {
  return (
    <div className={styles.container}>
      {!hideHeader && (
        <div>
          <h2 className={styles.title}>연락처 정보</h2>
          <p className={styles.description}>프로듀서가 연락할 수 있는 정보를 입력하세요.</p>
        </div>
      )}
      <div className={styles.card}>
        <FieldRow>
          <Field label="이메일" required>
            <input
              value={email} onChange={(e) => setEmail(e.target.value)}
              style={{ width: '100%', boxSizing: 'border-box', padding: '12px 14px', border: '1px solid #E9E9EC', borderRadius: '10px', fontSize: '15px', fontFamily: 'Pretendard, sans-serif', color: '#090909', outline: 'none', background: '#fff' }}
            />
          </Field>
          <Field label="연락처">
            <input
              value={formatPhone(phone)} readOnly disabled
              style={{ width: '100%', boxSizing: 'border-box', padding: '12px 14px', border: '1px solid #E9E9EC', borderRadius: '10px', fontSize: '15px', fontFamily: 'Pretendard, sans-serif', color: '#A2A2A2', outline: 'none', background: '#F5F5F7', cursor: 'not-allowed' }}
            />
          </Field>
        </FieldRow>
        <FieldRow>
          <Field label="인스타그램">
            <InstagramInput value={instagram} onChange={setInstagram} />
          </Field>
          <Field label="유튜브">
            <input
              value={youtube} onChange={(e) => setYoutube(e.target.value)}
              placeholder="https://youtube.com/@채널명"
              style={{ width: '100%', boxSizing: 'border-box', padding: '12px 14px', border: '1px solid #E9E9EC', borderRadius: '10px', fontSize: '15px', fontFamily: 'Pretendard, sans-serif', color: '#090909', outline: 'none', background: '#fff' }}
            />
          </Field>
        </FieldRow>
      </div>
    </div>
  );
}
